import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDateTime } from "../lib/api";
import { EmptyState, Panel, Spinner } from "../components/common";

export default function Notifications({ onRead, base = "" }) {
  const [d, setD] = useState(null);
  const load = () => api.get("/notifications").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const read = async (id) => { await api.post("/notifications/read", id ? { id } : {}); load(); onRead?.(); };
  if (!d) return <Spinner />;
  return (
    <Panel title={`Notifications (${d.unread} unread)`} testid="notifications-panel" action={d.unread > 0 && <button onClick={() => read()} className="text-sm font-semibold text-red-600" data-testid="notifications-read-all">Mark all read</button>}>
      {d.items.length ? (
        <ul className="divide-y divide-slate-100">
          {d.items.map((n) => (
            <li key={n.id} className={`flex items-start justify-between gap-3 py-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notification-${n.id}`}>
              <div>
                <p className="font-semibold">{!n.read && <span className="mr-2 inline-block h-2 w-2 rounded-full bg-red-600" />}{n.title}</p>
                {n.body && <p className="text-sm text-slate-600">{n.body}</p>}
                <p className="text-xs text-slate-400">{fmtDateTime(n.created_at)} · {n.type}</p>
              </div>
              <div className="flex shrink-0 gap-3 text-xs font-semibold">
                {n.link && <Link to={n.link} onClick={() => !n.read && read(n.id)} className="text-red-600">Open</Link>}
                {!n.read && <button onClick={() => read(n.id)} className="text-slate-500">Mark read</button>}
              </div>
            </li>
          ))}
        </ul>
      ) : <EmptyState>You're all caught up — no notifications.</EmptyState>}
    </Panel>
  );
}
